import { getDepositPromoStatus, getDepositPromoDetail } from '@/assets/api/deposit-promo'

/**
 * 校验当前店铺是否需要弹出保证金/推广金缴纳引导
 * @returns {Promise<object|null>} 需要弹窗时返回 detail 数据，否则返回 null
 */
export async function fetchDepositPromoIfNeeded($axios) {
  const res = await getDepositPromoStatus($axios)
  if (res.code !== 0 || !res.data) {
    return null
  }
  const { needPayment, locked } = res.data
  // needPayment=false 说明该店铺不走新流程，按原逻辑放行
  if (!needPayment || !locked) {
    return null
  }
  const detailRes = await getDepositPromoDetail($axios)
  if (detailRes.code === 0) {
    return detailRes.data
  }
  return null
}
